import styled from 'styled-components';

import { BurgerProps } from '../Components/Burger/Burger';

import { DashNavLink } from './NavBarStyles';

import { InputStyled, RelativeInputDiv } from '.';

export const Res = styled.div<BurgerProps>`
  flex-flow: column nowrap;
  background-color: #191970;
  position: fixed;
  transform: ${({ open }) => (open ? 'translateX(0%)' : 'translateX(100%)')};
  top: -17px;
  right: 0;
  height: 100vh;
  width: 220px;
  padding: 3.5rem;
  transition: transform 0.3s ease-in-out;
  li {
    color: #fff;
    &::focus-within ul {
      color: white;
    }
  }
`;

export const ResponsiveLink = styled(DashNavLink)`
  color: white;
  font-size: 40px;
  &::after {
    display: none;
  }
`;

export const ResponsiveIcons = styled.div`
  position: fixed;
  top: 45px;
  left: 15px;
`;

export const ResIcon = styled.img`
  width: 20px;
  margin: 3px;
`;

export const List = styled.ul`
  list-style: none;
  position: fixed;
  top: 150px;
  right: 60px;
  text-align: center;
`;

export const ResponsiveSearch = styled(RelativeInputDiv)`
  width: 200px;
  margin-right: 20px;
`;

export const ResponsiveSearchInput = styled(InputStyled)`
  background-color: ${(props) => props.theme.colors.lightGray};
`;
